import React,{useEffect,useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import { deleteEvent, getMyEvents,clearError,reorderList, deleteGuestListThunk } from '../../../redux/reducers/eventSlice'
import './eventPage.css'
import {useNavigate} from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DialogTitle from '@mui/material/DialogTitle';
import {snackbarContext} from '../../helpers/Snakbar'
import dayjs from 'dayjs';
import { clearUser, enableGrouping } from '../../../redux/reducers/authSlice';
import {DragDropContext,Droppable,Draggable} from 'react-beautiful-dnd'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import CreateIcon from '@mui/icons-material/Create';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EventIcon from '@mui/icons-material/Event';
import Navbar from '../../helpers/Navbar';
import { TabTitle } from '../../helpers/GeneralFunctions'
import Loader from '../../helpers/Loader'
import Stepper from '../Forms/Stepper'
import GroupingModal from './GroupingModal'
import DefaultInviteModal from "./DefaultInviteModal";

const EventPage = () => {
TabTitle("Events")
  const setStateSnackbarContext=React.useContext(snackbarContext)
   const navigate=useNavigate()
  const dispatch=useDispatch()
  const [open, setOpen] = useState(false);
  const {user,error:authError} = useSelector(state => state.auth);
  const [deleteEventId, setDeleteEventId] = useState(null);
     const [groupSelections, setGroupSelections] = useState({});
     const [defaultInviteModal, setDefaultInviteModal] = useState(false);
 const [deleteGuestListCode, setDeleteGuestListCode] = useState(null);
const [openGuestDelete, setOpenGuestDelete] = useState(false);
  const {events,error:backendError,loading,guestLists}=useSelector((state)=>state.event)
  const [guestListScreen,setguestListScreen]=useState(false)
  const [groupingModal,setGroupingModal]=useState({
    open: false,
    mode: "create",
    guestList: null
})
  // const [openGroups, setOpenGroups] = useState({}); 
  const now = new Date().getTime();
const expiryTime = new Date(user && user.demoExpiryTime).getTime();
const isDemoExpired = user && user.demoVersion && expiryTime && now > expiryTime;
const isInviteExpired= user && user.inviteTimeExpired

if(isInviteExpired){
 navigate("/")
}

if(isDemoExpired){
  navigate("/")
}

if(user && user.needsDate===true){
  navigate("/")
}

  const fetchEVents=()=>{
      dispatch(getMyEvents())
  }

   if (authError === "session expired") {
        setStateSnackbarContext(true, "session expired please login again", "error");
        dispatch(clearError());
        dispatch(clearUser())
        navigate("/login")
      } else if (backendError) {
        setStateSnackbarContext(true, backendError, "error");
        dispatch(clearError());
      }

  useEffect(()=>{
  fetchEVents()

  },[])
 

  useEffect(()=>{
    if (backendError === "session expired" || backendError==="pls login to acess the resource") {
      setStateSnackbarContext(true, "session expired please login again", "error");
      dispatch(clearError());
      dispatch(clearUser())
      navigate("/login")
    } else if (backendError) {
      setStateSnackbarContext(true, backendError, "error");
      dispatch(clearError());
    }
  },[backendError])



  if(user && user.hasEnded){
    navigate("/display/notfound")
    }
    

  const handleClickOpen = (id) => {
    setDeleteEventId(id); // Set the id of the event to be deleted
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteEventId(null);
    setOpen(false);
  };

  const handleGuestListClose=()=>{
    setDeleteGuestListCode(null)
    setOpenGuestDelete(false)
  }
  const deleteFunc=()=>{
    const id=deleteEventId
   dispatch(deleteEvent({id,setStateSnackbarContext})).then(() => {
      dispatch(getMyEvents());
  });
   setDeleteEventId(null);
    setOpen(false)
  }

  const deleteGuestListFunc=()=>{
    dispatch(deleteGuestListThunk({code: deleteGuestListCode,setStateSnackbarContext,handleGuestListClose}))
  }



  const onDragEnd=(result)=>{
    if(!result.destination) return;
    const newItems = Array.from(events);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed)
     dispatch(reorderList(newItems))
  }


const defaultInviteEvents = events.filter(
    event => event.showInMainInvite
);


const handleAddNewEvent = () => {
  if (user?.demoVersion && events.length >= 3) {
    setStateSnackbarContext(
      true,
      "You’ve reached the 3-event trial limit. Upgrade to create more events.",
      "warning"
    );
    return;
  }

  navigate("/event/new");
};

const handleGuestListClick = () => {
  if (user?.demoVersion) {
    setStateSnackbarContext(
      true,
      "Guest Lists is a premium feature. Upgrade to unlock it.",
      "warning"
    );
    return;
  }

  setguestListScreen(true);
};

  if(loading){
    return <Loader/>
  }
  return (
  <>
  <Navbar/>
    {!guestListScreen && <Stepper step={2} demoVersion={user && user.demoVersion} />} 
  {/* <PreviewButton onClick={() => navigate(`/private/preview/${user && user.userCode}`)} specialup={true}  /> */}
  <div className={`display-container`}>
  {guestListScreen && <div
    className="guest-back-btn"
    onClick={() => setguestListScreen(false)}
>
    <ArrowBackIcon className="guest-back-icon" />
    <span>Back</span>
</div>}
   {guestListScreen ? <h1 className='events-heading'>Guest Lists</h1> :<h1 className='events-heading'>Events</h1>} 
  

 {guestListScreen ?  <>
   <p className="guest-list-subtitle">
   Create guest lists and share different invite links with family, friends or office guests.
</p>

<button className="new-group-btn" onClick={()=>setGroupingModal({
        open: true,
        mode: "create",
        guestList: null
    })}>
    + New Guest List
</button>


{guestLists && guestLists.length > 0 && (

    <div className="guest-card default-invite-card">

        <div className="guest-card-header">
            <h3>Main Invitation</h3>
        </div>

        <span className="guest-card-label">
          Choose which events are visible on this invite link
        </span>

        <div className="guest-events">

            {defaultInviteEvents.length > 0 ? (

                defaultInviteEvents.map(event => (
                    <span key={event._id}>
                        {event.eventName}
                    </span>
                ))

            ) : (

                <span className="no-events-chip">
                    No events selected
                </span>

            )}

        </div>

        <div className="guest-card-actions">

            <button
                className="edit-btn"
                onClick={() => setDefaultInviteModal(true)}
            >
                Edit
            </button>

        </div>

    </div>

)}

{guestLists && guestLists.length > 0 ? (
  guestLists.map((guestList) => {

    const guestEvents = events.filter(event =>
      event.group?.includes(guestList.code)
    );

    return (
      <div className="guest-card" key={guestList.code}>

        <div className="guest-card-header">
          <h3>{guestList.groupname}</h3>
        </div>

        <span className="guest-card-label">
          Included Events
        </span>

        <div className="guest-events">

          {guestEvents.length > 0 ? (
            guestEvents.map(event => (
              <span key={event._id}>
                {event.eventName}
              </span>
            ))
          ) : (
            <span className="no-events-chip">
              No Events
            </span>
          )}

        </div>

        <div className="guest-card-actions">
          <button
            className="edit-btn"
             onClick={() => {
        const eventIds = events
            .filter(event =>
                event.group?.includes(guestList.code)
            )
            .map(event => event._id);
        setGroupingModal({
            open: true,
            mode: "edit",
            guestList: {
                ...guestList,
                eventIds
            }
        });
    }}
          >
            Edit
          </button>

          <button
            className="delete-btn"
             onClick={() => {
        setDeleteGuestListCode(guestList.code)
        setOpenGuestDelete(true);
    }}
          >
            Delete
          </button>

        </div>

      </div>
    );

  })
) : (
     <div className="guest-list-empty-div">
         <img src="/list.png" alt="" />
      <h3>No guest lists yet</h3>
      <span>Create your first guest list to share different invite links.</span>
     </div>
)}
 </>: <>
  {events && events.length>=2 &&
      <div className="grouping-enable-note">
         {/* <p className="note-text">Need different invites for different guests?</p> */}
              <p className="note-text">Want different events for different guests?</p>
           <div className="note-example">
    <span>Everyone: Wedding + Haldi</span>
    <span>Office friends: Haldi + Reception</span>
  </div>
  <button onClick={handleGuestListClick} > {user?.demoVersion ? "🔒" :"" }  Create Guest Lists</button>
      </div>
} 
 {events.length > 1 && <p className='drag-helper-text'>(Drag the <DragIndicatorIcon/> icon to reorder events)</p>  }
 <DragDropContext onDragEnd={onDragEnd}>
    <div  > 
    <Droppable droppableId="droppable-1" >
    {(provided)=>(
      <div ref={provided.innerRef}  {...provided.droppableProps}   >
      {events && (events.length>0)? events.map((event,i)=>(
         <>
        <Draggable key={event?._id} draggableId={"draggable-"+(event?._id || i)} index={i}  > 
        {((provided,snapshot)=>(
        <>
        
        <div className="display-card"  ref={provided.innerRef}  {...provided.draggableProps} style={{...provided.draggableProps.style,boxShadow:snapshot.isDragging?"0 0 .4rem #666":"none"}}>
        <div className='display-card-event-details'>
  <div className="drag-div" {...provided.dragHandleProps}>
      <DragIndicatorIcon className='drag-icon'/>
  </div>
  <div className="event-icon-div">
    <EventIcon className='event-icon'/>
  </div>
  <div className="event-details">
     <p>{event?.eventName}</p>
     <p>Time: {event?.eventTime ? event.eventTime : 'NA'}</p>
     <p>Date: {dayjs(event?.eventDate).format('DD-MM-YYYY')}</p>
  </div>
  <div className="event-action-div">
   <CreateIcon className='action-button edit' onClick={() => navigate(`/event/${event._id}`)} />
   <DeleteForeverIcon className='action-button delete'  onClick={() => handleClickOpen(event._id)}/>

   <Dialog
                          open={open && deleteEventId === event._id}
                          onClose={handleClose}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogTitle id="alert-dialog-title">{'Are you Sure?'}</DialogTitle>
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              Once deleted cannot be recovered back
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose}>Disagree</Button>
                            <Button onClick={() => deleteFunc(event._id)} autoFocus>
                              Agree
                            </Button>
                          </DialogActions>
                        </Dialog>
  </div>
 </div>
</div>
              </>
   ))}
</Draggable>

</>
  )):<div className='noEvents-div'>
    <img src="/step2.png" alt="" />
    <h3>No events added yet</h3>
    <span>Create your first wedding event to get started</span>
    <button onClick={()=>navigate("/event/new")}>Add New Event</button>
  </div>}
 
      </div>
    )} 
</Droppable>
</div>
</DragDropContext>
{events.length>0&&<button className='newEventButton next-step-button' onClick={handleAddNewEvent}>Add Another Event +</button> }
{events.length>0&&<button className='newEventButton ' onClick={()=>navigate("/preview")}>Next Step: View Your Invitation →</button> }
 </>}


   
</div>
{groupingModal.open && <GroupingModal  onClose={setGroupingModal}  events={events}   mode={groupingModal.mode}  guestList={groupingModal.guestList} />}
{defaultInviteModal && (
    <DefaultInviteModal
        onClose={setDefaultInviteModal}
        events={events}
    />
)}
<Dialog 
open={openGuestDelete}
onClose={handleGuestListClose}
aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"

 >
                          <DialogTitle id="alert-dialog-title">{'Delete Guest List'}</DialogTitle>
                            <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                             This will remove the guest list and
                             all event assignments linked to it. <br />
                             This action cannot be undone.
                            </DialogContentText>
                           
                          </DialogContent>
                          <DialogActions>
              <Button onClick={handleGuestListClose}>Disagree</Button>
              <Button onClick={deleteGuestListFunc}autoFocus>
                              Agree
                      </Button> 
                      </DialogActions>          
 </Dialog>
</>
  )
}

export default EventPage



